/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-array-index-key */
import {
    AccordionItem, AccordionItemBody, AccordionItemHeader, Accordions, Table,
} from 'appkit-react';
import { Col, Row } from 'react-bootstrap';

const FFIEC009ResultsAccordian = (
    {
        columns, criteria, fetchData, data, pages, pagesize,
        setPageSize, setPageNumber, pageSizeOptions,
    },
) => (
    <div>
        <Accordions className="true-comply-ffiec009-accordion" activeItem={['panel-1', 'panel-2']}>
            <AccordionItem itemId="panel-1" size="lg">
                <AccordionItemHeader className="background-white header" title="DIAGNOSTIC CRITERIA" />
                <AccordionItemBody className="background-white" size="lg">
                    <hr style={{ marginTop: 0 }} />
                    <Row>
                        <Col md={6}>
                            {!criteria?.aggregateRule && (
                                <Row className="row-margin">
                                    <Col md={3} className="a-h6">
                                        MDRM Number
                                        <span className="label">: </span>
                                    </Col>
                                    <Col md={8}>
                                        {criteria?.mdrmNumber}
                                    </Col>
                                </Row>
                            )}
                            <Row className="row-margin">
                                <Col md={3} className="a-h6">
                                    Description
                                    <span className="label">: </span>
                                </Col>
                                <Col md={8}>
                                    {criteria?.editTest}
                                </Col>
                            </Row>
                            <Row className="row-margin">
                                <Col md={3} className="a-h6">
                                    Aggregate Rule
                                    <span className="label">: </span>
                                </Col>
                                <Col md={8}>
                                    {criteria?.aggregateRule ? 'Y' : 'N'}
                                </Col>
                            </Row>
                        </Col>
                        <Col md={6}>
                            <Row className="row-margin">
                                <Col md={3} className="a-h6">
                                    Effective End Date
                                    <span className="label">: </span>
                                </Col>
                                <Col md={8}>
                                    {criteria?.effectiveEndDate}
                                </Col>
                            </Row>
                            <Row className="row-margin">
                                <Col md={3} className="a-h6">
                                    Edit Number
                                    <span className="label">: </span>
                                </Col>
                                <Col md={8}>
                                    {criteria?.editNumber}
                                </Col>
                            </Row>
                            {!criteria?.aggregateRule && (
                                <Row className="row-margin" style={{ paddingBottom: '1.5rem' }}>
                                    <Col md={3} className="a-h6">
                                        Schedule / Part
                                        <span className="label">: </span>
                                    </Col>
                                    <Col md={8}>
                                        {`${criteria?.schedule} / ${criteria?.targetItem}`}
                                    </Col>
                                </Row>
                            )}
                        </Col>
                    </Row>
                </AccordionItemBody>
            </AccordionItem>
            <AccordionItem itemId="panel-2" style={{ marginTop: '1rem' }} size="lg">
                <AccordionItemHeader className="background-white header" title="RESULTS" />
                <AccordionItemBody className="background-white" size="lg">
                    <hr style={{ marginTop: 0 }} />
                    <Row>
                        <Col md={6}>
                            {data.length > 0 && (
                                <Row>
                                    <Col md={3} className="a-h6">
                                        Run Date
                                        <span className="label">: </span>
                                    </Col>
                                    <Col md={8}>
                                        {data[0].testDate}
                                    </Col>
                                </Row>
                            )}
                            {data.length > 0 && (
                                <Row className="row-margin">
                                    <Col md={3} className="a-h6">
                                        Test Failed
                                        <span className="label">: </span>
                                    </Col>
                                    <Col md={8}>
                                        {data[0].testFail}
                                    </Col>
                                </Row>
                            )}
                            {data.length > 0 && !criteria?.aggregateRule && (
                                <Row className="row-margin">
                                    <Col md={3} className="a-h6">
                                        Error Message
                                        <span className="label">: </span>
                                    </Col>
                                    <Col md={9}>
                                        {data[0].errorMessage}
                                    </Col>
                                </Row>
                            )}
                        </Col>
                        <Col md={6}>
                            {data.length > 0 && (
                                <Row className="row-margin">
                                    <Col md={3} className="a-h6">
                                        Test Errored
                                        <span className="label">: </span>
                                    </Col>
                                    <Col md={8}>
                                        <div>
                                            {data[0].testError}
                                        </div>
                                    </Col>
                                </Row>
                            )}
                            {data.length > 0 && (
                                <Row>
                                    <Col md={3} className="a-h6">
                                        Test Status
                                        <span className="label">: </span>
                                    </Col>
                                    <Col md={8}>
                                        {data[0].testRunStatus}
                                    </Col>
                                </Row>
                            )}
                        </Col>
                    </Row>
                    <hr style={{ marginTop: 0 }} />
                    <Table
                        columns={columns}
                        striped
                        manual
                        data={data}
                        pages={pages}
                        onFetchData={fetchData}
                        defaultPageSize={pagesize}
                        onPageSizeChange={pageSize => setPageSize(pageSize)}
                        onPageChange={pageIndex => setPageNumber(pageIndex + 1)}
                        pageSizeOptions={pageSizeOptions}
                        noDataText="No Failed Data ..!!!"
                    />
                </AccordionItemBody>
            </AccordionItem>
        </Accordions>
    </div>
);

export default FFIEC009ResultsAccordian;
